/** `Object.entries(record)` in the order a plain `.sort()` gives its keys. */
export const sortedEntries = <T>(record: Record<string, T>): [string, T][] =>
  Object.entries(record).sort(([a], [b]) => (a < b ? -1 : 1))
